export abstract class WebAppProject
{
  _wasSavedOnce:boolean = false;
  _hasChanges:boolean = false;
  
  abstract serialize():Promise<Int8Array>;
  abstract deserialize( data:Int8Array ):Promise<void>;
}